import { Organization } from '@shared/models/Organization';
import { ApiResponse, PaginatedResponse } from '../types/api';
import { get } from './api';

/**
 * 机构服务
 */
export class OrganizationService {
  /**
   * 获取机构列表
   */
  static async getOrganizations(): Promise<Organization[]> {
    try {
      // 由于 middleware 会将数组包装成分页格式，我们需要处理分页响应
      const response = await get<any>('/organizations');
      console.log('OrganizationService response:', response);
      
      // 如果返回的是分页格式，取 list；如果是数组，直接返回
      if (response && typeof response === 'object' && 'list' in response) {
        const list = response.list || [];
        console.log('OrganizationService extracted list:', list);
        return list;
      }
      // 如果直接返回数组
      if (Array.isArray(response)) {
        console.log('OrganizationService response is array:', response);
        return response;
      }
      console.warn('OrganizationService unexpected response format:', response);
      return [];
    } catch (error) {
      console.error('OrganizationService error:', error);
      throw error;
    }
  }

  /**
   * 获取机构详情（公开接口，用于H5）
   */
  static async getOrganizationById(id: string): Promise<Organization> {
    return get<Organization>(`/public/organizations/${id}`);
  }
}

